import { Component, OnInit } from "@angular/core";
import { environment } from "../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "app1";
  userAgent = (() => {
    const ua = navigator.userAgent || "";
    const isWA =
      /WhatsApp/i.test(ua) ||
      /\[WAiOS\//i.test(ua) ||
      /\[WABIZ\//i.test(ua) ||
      /WA4A\//i.test(ua);
    const isAndroid = /Android/i.test(ua);
    return `WA:${isWA} | AND:${isAndroid} | ${ua}`;
  })();

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    const param_r: string = "r";
    const param_a: string = "a";

    this.activatedRoute.queryParams.subscribe((params) => {
      let id: string;
      if (params) {
        if (params[param_r]) {
          id = params[param_r];
        } else if (params[param_a]) {
          id = params[param_a];
        }
        if (id) {
          const baseUrl = this.router.url.split("?")[0];
          this.router.navigate([`${baseUrl}/${id}`]);
        }
      }
    });
    this.loadNewrelicScript();
  }

  public loadNewrelicScript() {
    const head = <HTMLDivElement>document.head;
    const script = document.createElement("script");

    if (environment.env == "prod") {
      script.src = "./assets/scripts/newrelic/prod.js";
    } else if (environment.env == "qa") {
      script.src = "./assets/scripts/newrelic/qa.js";
    } else {
      script.src = "./assets/scripts/newrelic/staging.js";
    }
    head.appendChild(script);
  }
}

const API_VERSION_V1 = "v1";
const API_VERSION_V2 = "v2";
const API_VERSION_V3 = "v3";
/**
 * Global variable declaration for api route
 */
export const GlobalVariable = Object.freeze({
  BASE_API_URL: environment.apiHost,

  /** Public logo url */
  PUBLIC_LOGO_URL: API_VERSION_V1 + "/business/public-logo/",
  FEEDBACK_SLUG_DATA: API_VERSION_V1 + "/contact/slug/contact",

  /** review reply feedback page api */
  INTERNAL_REPLAY_SLUG_URL: API_VERSION_V1 + "/review/slug/feedback-reply/load",

  /** Customer sent reviews urls */
  SMS_FEEDBACK_URL: API_VERSION_V1 + "/review/slug/has-feedback",
  SMS_SLUG_REQUEST_URL: API_VERSION_V1 + "/review/slug/feedback",
  SMS_SLUG_URL: API_VERSION_V1 + "/review/slug/load",
  REVIEW_RATING_API: API_VERSION_V1 + "/review/update/actions",
  REVIEW_RATING_SLUG: API_VERSION_V2 + "/review/slug",
  GET_APPOINTMENT_METADATA: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/appointment-slug`,
  GET_TAG_TEAM_MEMBERS: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/tag-team-member/list`,
  GET_BOOKING_SLOTS: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/booking-slots`,
  BOOK_APPOINTMENT_V3: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/consumer-booking`,
  GET_BOOKING_DETAILS: (slug, booking_id) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/appointment/${booking_id}`,
  BOOK_INQUIRY: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/enquiry/create`,
  GET_INQUIRY_DETAILS: (slug, inquiry_id) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/enquiry/${inquiry_id}`,

  /** Campaign sms tracking */
  CAMPAIGN_TRACKING: API_VERSION_V1 + "/campaign/tracking",

  /* Optin **/
  OPTIN_TRACKING: API_VERSION_V1 + "/review/optin",
  OPTOUT_TRACKING: API_VERSION_V1 + "/review/optout",
  OPTIN: (slug) => API_VERSION_V2 + `/review/${slug}/optin`,

  // Customer Appointment Booking
  APPOINTMENT_SLUG: API_VERSION_V2 + "/appointment/appointment-slug",
  TEAM_MEMBERS: API_VERSION_V2 + "/appointment/tag-member/list",

  AVAILABLE_SLOTS: API_VERSION_V2 + "/appointment/available-booking-slots",
  BOOK_APPOINTMENT: API_VERSION_V2 + "/appointment/consumer-booking",
  WHATSAPP_VERIFY: API_VERSION_V2 + "/interaction-management/verify-whatsapp",

  GET_DELETE_APPOINTMENT_SLUG:
    API_VERSION_V3 + "/appointment-consumer/appointment",
  DELETE_APPOINTMENT: API_VERSION_V3 + "/appointment-consumer/delete",

  // QR Code URL
  QR_PUBLIC_DETAILS: API_VERSION_V1 + "/business/qr-public-details",
  POST_CUSTOMER_DETAILS: API_VERSION_V1 + "/review/qr-code/details",

  // AI Review Generator
  AI_REVIEW_BOOTSTRAP: API_VERSION_V2 + "/review/slug/ai-review/bootstrap",
  AI_REVIEW_GEN_BOOTSTRAP: API_VERSION_V2 + "/review/slug/ai-review/gen-bootstrap",
  AI_REVIEW_GEN_DRAFT: API_VERSION_V2 + "/review/slug/ai-review/gen-draft",
  AI_REVIEW_WORD_POOL: API_VERSION_V2 + "/review/slug/ai-review/word-pool",
  AI_REVIEW_GENERATE: API_VERSION_V2 + "/review/slug/ai-review/generate",
  AI_REVIEW_REFINE: API_VERSION_V2 + "/review/slug/ai-review/refine",
  AI_REVIEW_CAPTURE: API_VERSION_V2 + "/review/slug/ai-review/capture",
  AI_REVIEW_OTHERS_INTENTS: API_VERSION_V2 + "/review/slug/ai-review/others-intents",
});
